import {
  MERCHANT_FETCH,
  MERCHANT_FETCH_SUCCESS,
  MERCHANT_FETCH_FAIL,
  CHANGE_SELECT_MERCHANT,
  MERCHANT_SUMMARY_FETCH,
  MERCHANT_SUMMARY_FETCH_SUCCESS,
  MERCHANT_SUMMARY_FETCH_FAIL,
  CREATE_NEW_MERCHANT,
  CREATE_NEW_MERCHANT_SUCCESS,
  CREATE_NEW_MERCHANT_FAIL,
  LOAD_MERCHANT,
  LOAD_MERCHANT_SUCCESS,
  LOAD_MERCHANT_FAIL,
  UPDATE_MERCHANT,
  UPDATE_MERCHANT_SUCCESS,
  UPDATE_MERCHANT_FAIL,

} from '../actions';

export const merchantFetch = (merchant, history, desiredPath) => ({
  type: MERCHANT_FETCH,
  payload: { merchant, history, desiredPath }
});

export const merchantSuccess = (merchant) => ({
  type: MERCHANT_FETCH_SUCCESS,
  payload: merchant
});

export const merchantFail = (message) => ({
  type: MERCHANT_FETCH_FAIL,
  payload: { message }
});

export const changeSelectMerchant= (selectMercahntid) => {
    return (
        {
            type: CHANGE_SELECT_MERCHANT,
            payload: selectMercahntid
        }
    )
}

export const merchantSummaryFetch = (merchantSummary) => ({
  type: MERCHANT_SUMMARY_FETCH,
  payload: { merchantSummary }
});

export const merchantSummarySuccess = (merchantSummary) => ({
  type: MERCHANT_SUMMARY_FETCH_SUCCESS,
  payload: { merchantSummary }
});

export const merchantSummaryFail = (message) => ({
  type: MERCHANT_SUMMARY_FETCH_FAIL,
  payload: { message }
});


export const createMerchant = (merchantCreate) => ({
	type: CREATE_NEW_MERCHANT,
	payload: { merchantCreate }
 });

 export const createMerchantSuccess = (merchantCreate) => ({
	type: CREATE_NEW_MERCHANT_SUCCESS,
	payload: { merchantCreate }
 });
 
 export const createMerchantFail = (message) => ({
	type: CREATE_NEW_MERCHANT_FAIL,
	payload: { message }
 });

 export const loadMerchant = (merchantLoad) => ({
	type: LOAD_MERCHANT,
	payload: { merchantLoad }
 });

 export const loadMerchantSuccess = (merchantLoad) => ({
	type: LOAD_MERCHANT_SUCCESS,
	payload: merchantLoad
 });
 
 export const loadMerchantFail = (merchantLoad) => ({
	type: LOAD_MERCHANT_FAIL,
	payload: { merchantLoad }
 });


 export const updateMerchant = (merchantUpdate) => ({
	type: UPDATE_MERCHANT,
	payload: { merchantUpdate }
 });

 export const updateMerchantSuccess = (merchantUpdate) => ({
	type: UPDATE_MERCHANT_SUCCESS,
	payload: { merchantUpdate }
 });
 
 export const updateMerchantFail = (message) => ({
	type: UPDATE_MERCHANT_FAIL,
	payload: { message }
 });